import * as React from 'react'

import { cn } from '@/shared/lib/utils'

function Textarea({
	className,
	invalid,
	...props
}: React.ComponentProps<'textarea'> & { invalid?: boolean }) {
	return (
		<textarea
			data-slot='textarea'
			aria-invalid={invalid}
			className={cn(
				'flex min-h-16 w-full rounded-lg border border-input bg-input/20 px-3 py-2 text-sm placeholder:text-sm placeholder:text-placeholder dark:bg-input/30',
				'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30 focus-visible:outline-hidden',
				'aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20',
				'disabled:cursor-not-allowed disabled:opacity-50',
				className
			)}
			{...props}
		/>
	)
}

export { Textarea }
